
class  NavEvents  {

    constructor(el, func, horizontal = false){
        this.lang = 1;

        this.xDown = null;
        this.yDown = null;

        this.scrolling = false;
        this.trashScroll = 0;

        window.navE = this;



        this.wheelSwitch = function(b){



            if(b){






                if(!this.isFF()){
                    el.addEventListener('wheel', this.evWeel, false);
                }else{
                    el.addEventListener('wheel', this.evWeel2, false);
                }

                el.addEventListener('touchstart', this.handleTouchStart, false);
                el.addEventListener('touchmove', this.handleTouchMove, false);





            }else{

                if(!this.isFF()){
                    el.removeEventListener('wheel', this.evWeel, false);
                }else{
                    el.removeEventListener('wheel', this.evWeel2, false);
                }
                el.removeEventListener('wheel', this.evWeel, false);
                el.removeEventListener('touchstart', this.handleTouchStart, false);
                el.removeEventListener('touchmove', this.handleTouchMove, false);

            }




        }


        this.evWeel = function(e){



            console.log(e.cancelable);


            if(e.cancelable) {

                if(e.deltaY < 0) {
                    func(0);
                }else if(e.deltaY > 0){
                     func(1);
                }
            }
        }

        this.evWeel2 = function(e){



            if(!window.navE.scrolling) {
                if(e.deltaY < -1) {
                    func(0);
                    window.navE.refreshSrcoll();
                }else if(e.deltaY > 1){
                    func(1);
                    window.navE.refreshSrcoll();
                }



            }


            window.navE.trashScroll = Math.abs(e.deltaY);
        }

        this.refreshSrcoll = function(){

            window.navE.scrolling = true;
            window.navE.wheelSwitch(false);

            setTimeout(function(){
                window.navE.scrolling = false;
                window.navE.wheelSwitch(true);
            }, 1500);
        }

        this.refreshSrcollLoop = function(){
          //  console.log(window.navE.trashScroll );

            if(window.navE.trashScroll > 1){
                setTimeout(function(){
                    console.log( 'loop' );


                    window.navE.refreshSrcollLoop();
                }, 10);
            }else{

            }



        }


        /********************************************************************************
         ********************************************************************************
         ********************************************************************************
         ********************************************************************************
         ********************************************************************************/
        this.getTouches = function(evt) {
            return evt.touches ||             // browser API
                evt.originalEvent.touches; // jQuery
        }

        this.handleTouchStart = function(evt) {
            const firstTouch = window.navE.getTouches(evt)[0];
            this.xDown = firstTouch.clientX;
            this.yDown = firstTouch.clientY;
        }

        this.handleTouchMove = function(evt) {
            if ( ! this.xDown || ! this.yDown ) {
                return;
            }
            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = this.xDown - xUp;
            var yDiff = this.yDown - yUp;

            //    console.log('xDiff: ' + xDiff);
            //   console.log('yDiff: ' + yDiff);

            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/

                if ( xDiff > 0 ) {
                    if(horizontal){
                        func(1);
                    }
                } else {
                    if(horizontal){
                        func(0);
                    }
                }
            } else {
                if ( yDiff > 0 ) {
                    //   console.log('up');
                    func(1);

                } else {
                    /* down swipe */
                    // console.log('down');
                    func(0);
                }
            }
            /* reset values */
            this.xDown = null;
            this.yDown= null;
        }


        this.isFF = function(){
            return  navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        }













    }



};

export { NavEvents };



// WEBPACK FOOTER //
// ./src/dataModules/NavEvents.js